import { CKButton } from '@clearkit/react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import Footer from '~/components/Footer';
import TextField from '~/components/RedesignedTextField';

import CheckboxActive from './CheckboxActive.svg';
import CheckboxInactive from './CheckboxInactive.svg';
import styles from './styles';

function PlanOption({ name, description, classes, checked, onChange }) {
  return (
    <div className={classes.planOption}>
      <Checkbox
        checked={checked}
        checkedIcon={<CheckboxActive />}
        classes={{ root: classes.checkbox }}
        icon={<CheckboxInactive />}
        onChange={(event) => onChange(event.target.checked)}
        value={name.toLowerCase()}
      />
      <div>
        <span className={classes.optionName}>{name}</span>
        <p className={classes.optionDescription}>{description}</p>
      </div>
    </div>
  );
}

function RequestAccessForm({
  classes,
  values,
  onChange,
  onClose,
  valid,
  onSubmit,
  backPath,
}) {
  return (
    <form onSubmit={onSubmit} className={classes.formOuter}>
      <div className={classes.body}>
        <div className={classes.formInner}>
          <div className={classes.contactInfo}>
            <FormControl fullWidth className={classes.field}>
              <FormLabel>Email address*</FormLabel>
              <TextField
                onChange={(event) => onChange('email', event.target.value)}
                value={values.email}
              />
            </FormControl>

            <FormControl fullWidth className={classes.field}>
              <FormLabel>Name*</FormLabel>
              <TextField
                onChange={(event) => onChange('name', event.target.value)}
                value={values.name}
              />
            </FormControl>
          </div>

          <div className={classes.planOptions}>
            <p className={classes.choosePlan}>
              Choose the plans you&apos;d like to add to your account
            </p>

            <PlanOption
              name="Alerting"
              description="Send alerts to your team via destinations like Slack, Salesforce, Email or Webhooks when a person or company matches a segment."
              classes={classes}
              onChange={(value) => onChange('alerting', value)}
              checked={values.alerting}
            />

            <PlanOption
              name="Advertising"
              description="Automatically create highly targeted ads audiences when a person or company matches a  segment."
              classes={classes}
              onChange={(value) => onChange('advertising', value)}
              checked={values.advertising}
            />

            <PlanOption
              name="Personalization"
              description="Use Clearbit X segments to customize your website in realtime."
              classes={classes}
              onChange={(value) => onChange('personalization', value)}
              checked={values.personalization}
            />
          </div>

          <div className={classes.message}>
            <FormControl fullWidth className={classes.field}>
              <FormLabel>Message</FormLabel>
              <TextField
                onChange={(event) => onChange('message', event.target.value)}
                placeholder="Let us know a little more about what you're aiming to accomplish and if you have any additional requirements."
                value={values.message}
                multiline
                rows={3}
                InputProps={{ rel: 'message' }}
              />
            </FormControl>
          </div>
        </div>
      </div>
      <Footer
        right={
          <>
            <CKButton to={backPath} onClick={onClose}>
              Cancel
            </CKButton>
            <CKButton
              variant="bold"
              variantColor="blue"
              disabled={!valid}
              type="submit">
              Submit
            </CKButton>
          </>
        }
      />
    </form>
  );
}

RequestAccessForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  backPath: PropTypes.string,
  onClose: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
};

export default withStyles(styles)(RequestAccessForm);
